import { SourceDataFieldType } from "@/api/dtos";
import { ComponentType } from "react";
import SourceDataItemTextValue from "./SourceDataItemTextValue";
import { ISourceDataItemValueProps } from "./SourceDataItemValue";
import SourceDataItemCheckboxValue from "./SourceDataItemCheckboxValue";
import SourceDataItemLookupValue from "./SourceDataItemLookupValue";
import SourceDataItemDateValue from "./SourceDataItemDateValue";
import SourceDataItemMultiLookupValue from "./SourceDataItemMultiLookupValue";
import SourceDataItemCtcaeValue from "./SourceDataItemCtcaeValue";
import SourceDataItemFileValue from "./SourceDataItemFileValue";

export const SourceDataItemMapping: Record<SourceDataFieldType, ComponentType<ISourceDataItemValueProps>> = {
    [SourceDataFieldType.Checkbox]: SourceDataItemCheckboxValue,
    [SourceDataFieldType.Ctcae]: SourceDataItemCtcaeValue,
    [SourceDataFieldType.Date]: SourceDataItemDateValue,
    [SourceDataFieldType.File]: SourceDataItemFileValue,
    [SourceDataFieldType.Hidden]: SourceDataItemTextValue,
    [SourceDataFieldType.MultiSelect]: SourceDataItemMultiLookupValue,
    [SourceDataFieldType.MultilineText]: SourceDataItemTextValue,
    [SourceDataFieldType.Numeric]: SourceDataItemTextValue,
    [SourceDataFieldType.Radio]: SourceDataItemLookupValue,
    [SourceDataFieldType.Select]: SourceDataItemLookupValue,
    [SourceDataFieldType.Text]: SourceDataItemTextValue
}